import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';

const VariantControls = ({ variants, onChange, activeVariant }) =>
    map(variants, (variant, index) => (
        <span className="radio-group" key={index}>
            <input
                onChange={() => onChange && onChange(index)}
                checked={activeVariant === index}
                type="radio"
                id={`radio-id-${index}`}
                name="gallery-variants"
            />
            <label htmlFor={`radio-id-${index}`}>{variant.label}</label>
        </span>
    ));

VariantControls.propTypes = {
    onChange: PropTypes.func.isRequired,
    activeVariant: PropTypes.number,
    variants: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
        })
    ),
};

export default VariantControls;
